<template>
<body class="error">
    <router-view></router-view>
</body>
</template>

<script>
export default {
}
</script>